// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  API_KEY: "c8fca52a7c29d4c3a6bff472b1e2a6c35a7f58c1c52d6fae8b1f9a4e3a6d7b2a",
  ENCRYPTION_SECRET: "1837eb77e3296a93d04c2f4843556f02e238eada2e961059495df6b99032702b",
  production: false,
  // invoiceEmail: "AP-BA@bse.com",
  invoiceEmail: "accounting@vicimus.com",
  taxRate: [
    {province_code : "AB", rate: "0.05"},
    {province_code : "BC", rate: "0.05"},
    {province_code : "MB", rate: "0.05"},
    {province_code : "NB", rate: "0.15"},
    {province_code : "NL", rate: "0.15"},
    {province_code : "NT", rate: "0.05"},
    {province_code : "NS", rate: "0.15"},
    {province_code : "NU", rate: "0.05"},
    {province_code : "ON", rate: "0.13"},
    {province_code : "PE", rate: "0.15"},
    {province_code : "QC", rate: "0.05"},
    {province_code : "SK", rate: "0.05"},
    {province_code : "YT", rate: "0.05"}
  ]
};



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/environments/environment.ts